"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propsOrState = _interopRequireDefault(require("../../utils/propsOrState"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var defaultProps = {
  theme: {},
  name: null,
  disabled: false,
  indeterminate: false,
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  autoFocus: false,
  validateOn: 'change'
};

/**
 * Provides a checkbox field with different styles and states.
 */
var Checkbox = exports["default"] = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Checkbox, _React$Component);
  function Checkbox(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Checkbox);
    _this = _callSuper(this, Checkbox, [props]);
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.propsOrState = _propsOrState["default"].bind((0, _assertThisInitialized2["default"])(_this));
    var checked = props.checked,
      value = props.value;
    _this.state = {
      checked: value === undefined ? checked || false : value
    };
    return _this;
  }

  // eslint-disable-next-line camelcase
  (0, _createClass2["default"])(Checkbox, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps && nextProps.checked !== this.props.checked) {
        this.setState({
          checked: nextProps.checked
        });
      }
    }
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      if (!this.props.disabled) {
        this.props.onFocus();
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      if (!this.props.disabled) {
        this.props.onBlur();
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      var _this2 = this;
      if (this.props.disabled) {
        return;
      }
      var checked = !this.state.checked;
      var newState = {
        checked: checked
      };
      this.setState(newState, function () {
        _this2.props.onChange({
          value: checked
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        color = _this$props.color,
        label = _this$props.label,
        name = _this$props.name,
        indeterminate = _this$props.indeterminate,
        testId = _this$props.testId,
        className = _this$props.className,
        isFocused = _this$props.isFocused,
        disabled = _this$props.disabled,
        tabindex = _this$props.tabindex,
        value = _this$props.value,
        theme = _this$props.theme,
        autoFocus = _this$props.autoFocus,
        hideLabel = _this$props.hideLabel;
      var checked = value === undefined ? this.propsOrState('checked') : value;
      var isFocusedStatus = autoFocus || isFocused;
      var tabIndexValue;
      if (typeof tabindex !== 'undefined' && !disabled) {
        tabIndexValue = tabindex;
      }
      var classes = (0, _classnames["default"])(className, theme.checkbox, disabled && theme.disabled, checked && theme.checked, indeterminate && theme.indeterminate, !indeterminate && theme.regular, isFocusedStatus && theme.isFocused);
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: classes,
        "data-test-id": testId,
        "data-anypoint-component": Checkbox.displayName
      }, /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: name,
        className: "checkbox-wrapper"
      }, /*#__PURE__*/_react["default"].createElement("input", {
        className: "checkbox-input",
        id: name,
        type: "checkbox",
        checked: checked,
        name: name,
        disabled: disabled,
        autoFocus: autoFocus,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        tabIndex: tabIndexValue,
        onClick: this.handleClick,
        readOnly: true
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: theme.boxShape,
        style: color && checked ? {
          backgroundColor: color
        } : undefined
      }, indeterminate ? /*#__PURE__*/_react["default"].createElement("span", {
        className: (0, _classnames["default"])('indeterminate', theme.bar)
      }) : null), hideLabel ? /*#__PURE__*/_react["default"].createElement("span", {
        className: theme.assistiveText
      }, label) : /*#__PURE__*/_react["default"].createElement("span", {
        style: color ? {
          color: color
        } : undefined
      }, label)));
    }
  }]);
  return Checkbox;
}(_react["default"].Component);
(0, _defineProperty2["default"])(Checkbox, "defaultProps", defaultProps);
(0, _defineProperty2["default"])(Checkbox, "displayName", 'Checkbox');
//# sourceMappingURL=Checkbox.js.map